import * as s from "../../styles";

type MissionTitleProps = {
    children: React.ReactNode;
};

export const MissionTitle = ({ children }: MissionTitleProps) => {
    return <s.Title>{children}</s.Title>;
};
